import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import axios from 'axios';
import api from '../../config';
import '@fortawesome/fontawesome-free/css/all.min.css';
import eventsImage from '../assets/images/events.jpg';

const UpcomingEventSection = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLatestUpcomingEvent();
  }, []);

  const fetchLatestUpcomingEvent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/get/upcoming-events?limit=1`);
      
      if (response.data.isOk && response.data.data.length > 0) {
        setEvent(response.data.data[0]);
      } else {
        setEvent(null);
      }
    } catch (err) {
      console.error('Error fetching latest upcoming event:', err);
      setError('Failed to load upcoming event');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="upcoming-event-section py-5">
        <Container>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (!event) {
    return null; // Don't show section if no upcoming events
  }

  const eventDate = new Date(event.eventDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const bannerImageUrl = event.bannerImage ? `${api.API_URL}/${event.bannerImage}` : eventsImage;

  return (
    <section className="upcoming-event-section py-3 py-lg-5">
      <Container>
        <Row className="align-items-center">
          
          <Col lg={6} className="p-0">
            <div className="upcoming-event-img">
              <img 
                src={bannerImageUrl} 
                alt={event.title}
                className="img-fluid" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = eventsImage; // Fallback to default image
                }}
              />
            </div>
          </Col>

          <Col lg={6} className="d-flex align-items-center">
            <div className="upcoming-event-content p-lg-5 p-0 pt-3">
              <p className="upcoming-event-label">UPCOMING EVENT</p>
              <h2 className="upcoming-event-title">
                {event.title}
              </h2>
              <p className="upcoming-event-desc">
                {event.shortDescription}
              </p>
              <div className="upcoming-event-date d-flex align-items-center mt-2">
                <div className="date-icon me-2">
                  <i className="fa-regular fa-calendar"></i>
                </div>
                <span>{eventDate}</span>
              </div>

              <div className="see-more mt-0 mt-lg-3">
                <a href={`/event/${event.slug || event._id}`} className="see-more-link">
                  See More <i className="fas fa-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default UpcomingEventSection;
